var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { EMonitoringErrorCode, monitoringErrorCode, monitoringErrorMessage, monitoringProblems, } from "./errors";
/** Where Harvest puts a refused pick: `widget_selector_values.<widget>.<selector>`. */
var PICK_PATH = /^widget_selector_values\.([^.]+)\.(.+)$/;
/** Problem codes Harvest reports of an export (`sequent_core::monitoring::problem::Code`). */
var EExportProblem;
(function (EExportProblem) {
    EExportProblem["INVALID_VALUE"] = "invalid_value";
    EExportProblem["UNKNOWN_SELECTOR"] = "unknown_selector";
    EExportProblem["UNKNOWN_OPTION"] = "unknown_option";
})(EExportProblem || (EExportProblem = {}));
var RANGE_BOUNDS = new Set(["from", "to"]);
function describe(problem, t, widgets) {
    var _a, _b, _c, _d;
    if (problem.code === EExportProblem.INVALID_VALUE && RANGE_BOUNDS.has(problem.path)) {
        return t("monitoring.export.invalidRange");
    }
    var pick = PICK_PATH.exec(problem.path);
    if (pick &&
        (problem.code === EExportProblem.UNKNOWN_SELECTOR ||
            problem.code === EExportProblem.UNKNOWN_OPTION)) {
        var widgetId_1 = pick[1], name_1 = pick[2];
        var widget = widgets.find(function (candidate) { return candidate.id === widgetId_1; });
        var selector = (_c = (_b = (_a = widget === null || widget === void 0 ? void 0 : widget.selectors) === null || _a === void 0 ? void 0 : _a[name_1]) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : name_1;
        var key = problem.code === EExportProblem.UNKNOWN_SELECTOR
            ? "monitoring.export.problems.unknownSelector"
            : "monitoring.export.problems.unknownOption";
        return t(key, { widget: (_d = widget === null || widget === void 0 ? void 0 : widget.title) !== null && _d !== void 0 ? _d : widgetId_1, selector: selector });
    }
    return undefined;
}
/**
 * What the export dialog tells the viewer of a refused export: each problem
 * Harvest found, in the viewer's words where the view knows it, else the
 * refusal's own message with Harvest's words for the problem.
 */
export function exportFailure(error, t, widgets) {
    if (monitoringErrorCode(error) !== EMonitoringErrorCode.INVALID) {
        return t(monitoringErrorMessage(error));
    }
    var problems = monitoringProblems(error);
    var known = problems.map(function (problem) { return describe(problem, t, widgets); });
    if (problems.length && known.every(Boolean))
        return known.join(" ");
    return __spreadArray([
        t(monitoringErrorMessage(error))
    ], problems.map(function (problem, index) { var _a; return (_a = known[index]) !== null && _a !== void 0 ? _a : problem.message; }), true).filter(Boolean)
        .join(" ");
}
